import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './detailed-product-card.component.scss';
var DetailedProductCard = /** @class */ (function (_super) {
    tslib_1.__extends(DetailedProductCard, _super);
    function DetailedProductCard(element) {
        return _super.call(this, element) || this;
    }
    DetailedProductCard.prototype.init = function () {
        if (this.element.querySelector('.detailed-product-card__button')) {
            this.buttonContainers = Array.from(this.element.querySelectorAll('.detailed-product-card__button'));
            this.check();
        }
    };
    DetailedProductCard.prototype.bindEvents = function () {
    };
    DetailedProductCard.prototype.check = function () {
        var _this = this;
        this.buttonContainers.map(function (container) {
            var button = container.querySelector('a');
            var parentContainer = container.closest('.col');
            if (button.hasAttribute('downloadappandroid') ||
                button.hasAttribute('downloadappios') ||
                button.hasAttribute('downloadapphuawei') ||
                button.hasAttribute('downloadappdesktop')) {
                parentContainer.classList.add('d-none');
                if (_this.isIosDevice()) {
                    if (button.hasAttribute('downloadappios')) {
                        parentContainer.classList.remove('d-none');
                    }
                }
                else if (_this.isHauweiDevice()) {
                    if (button.hasAttribute('downloadapphuawei')) {
                        parentContainer.classList.remove('d-none');
                    }
                }
                else if (_this.isAndroidDevice()) {
                    if (button.hasAttribute('downloadappandroid')) {
                        parentContainer.classList.remove('d-none');
                    }
                }
                else {
                    if (button.hasAttribute('downloadappdesktop')) {
                        parentContainer.classList.remove('d-none');
                    }
                }
            }
        });
    };
    DetailedProductCard.prototype.isIosDevice = function () {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        return /iPad|iPhone|iPod/i.test(userAgent);
    };
    DetailedProductCard.prototype.isAndroidDevice = function () {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        return /android/i.test(userAgent);
    };
    DetailedProductCard.prototype.isHauweiDevice = function () {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        return /huawei/i.test(userAgent);
    };
    return DetailedProductCard;
}(Base));
export { DetailedProductCard };



//////////////////
// WEBPACK FOOTER
// ./components/detailed-product-card/detailed-product-card.component.ts
// module id = 262
// module chunks = 0